export function normalizeDocument(document) {
  return { ...document, id: document.id || document._id };
}

export function documentId(value) {
  const id = typeof value === 'object' && value ? value.id || value._id : value;
  if (!id || id === 'undefined' || id === 'null') throw new Error('Identifiant du document manquant');
  return encodeURIComponent(id);
}
